import { inject } from 'vue'
import type { App as VueApp, InjectionKey } from 'vue'
import { useSpace } from '@/store/modules/App/space'
import type { AppProvision } from '@/types'

export type UseApp = () => {
  isInstalled: (slug: string) => boolean
  installedApp: (slug: string) => AppProvision | undefined
}

export const useApps: UseApp = () => {
  const spaceStore = useSpace()

  const isInstalled: ReturnType<UseApp>['isInstalled'] = (slug) =>
    spaceStore.installedApps.some((app) => app.slug === slug)

  const installedApp: ReturnType<UseApp>['installedApp'] = (slug) =>
    spaceStore.installedApps?.find((app) => app.slug === slug)

  return { isInstalled, installedApp }
}

const IsAppInstalledInjectionKey = Symbol() as InjectionKey<
  ReturnType<UseApp>['isInstalled']
>

export default {
  install(app: VueApp) {
    const { isInstalled, installedApp } = useApps()

    app.config.globalProperties.$isAppInstalled = isInstalled
    app.config.globalProperties.$getAppInstalled = installedApp

    app.provide(IsAppInstalledInjectionKey, isInstalled)
  },
}

export function useAppInstalled() {
  return { isAppInstalled: inject(IsAppInstalledInjectionKey, () => false) }
}
